<button
  type="button"
  class="btn-impressao"
  (click)="onClick()"
  [disabled]="disabled"
>
<p>Imprimir detalhe</p>
  <img *ngIf="icon" [src]="icon" alt="Ícone de impressão" />
</button>
